var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('funding-base',{attrs:{"state":_vm.state}},[_c('div',{staticClass:"container"},[_vm._v("\n    funding pot settings\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }